export default {
    "tagsCreateEditTag_success": "Tag saved",
    "tagsCreateEditTag_editTitle": "Edit Tag",
    "tagsCreateEditTag_createTitle": "Create a New Tag",
    "tagsCreateEditTag_color": "Choose Label and Color",
    "tagsCreateEditTag_label": "Label",
    "tagsCreateEditTag_nestUnder": "Nest Under",
    "tagsCreateEditTag_typeToSearch": "Type to search...",

    "tagsCreateEditTag_tag": "Tag",
    "tagsCreateEditTag_vehicles": "Vehicles",
    "tagsCreateEditTag_drivers": "Drivers",
    "tagsCreateEditTag_landmarks": "Landmarks",
    "tagsCreateEditTag_users": "Users",
    "tagsCreateEditTag_forms": "Forms",
    "tagsCreateEditTag_dynamicForms": "Dynamic Forms",
    "tagsCreateEditTag_geofences": "Geofences",
    "tagsCreateEditTag_errorParentTag": 'You can not add the same tag as a parent',
    "tagsCreateEditTag_unit": "Units",
    "tagsCreateEditTag_account": "Accounts",

};